import React from 'react';
import { Translation } from 'react-i18next';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';

const STATE_OPTIONS = [
  { key: 1, value: 1, text: <Translation>{t => t('pending')}</Translation> },
  { key: 2, value: 2, text: <Translation>{t => t('active')}</Translation> },
  { key: 3, value: 3, text: <Translation>{t => t('disabled')}</Translation> },
];

const CommunityMemberStateFilter = () => (
  <IconFilter
    hasApplyButton
    name="stateId"
    position="bottom right"
    placement="bottom-end"
    as={FilterSelectComponent}
    options={STATE_OPTIONS}
  />
);

export default CommunityMemberStateFilter;
